import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { mainAnnouncementsState } from '../states/mainAnnouncementsState';
import { userState } from '../states/userState';
import useAxios from './useAxios';

const SESSION_KEY = 'hasShownAnnouncements';

const useAnnouncement = () => {
  const { requestAxios } = useAxios();
  const [{ userInfo }] = useRecoilState(userState);
  const [, setMainAnnouncements] = useRecoilState(mainAnnouncementsState);

  useEffect(() => {
    // 로그인 전이거나, 약관 미동의 시 공지 로딩 스킵
    if (!userInfo || userInfo.terms_agreed_at === null) {
      return;
    }

    // 이미 세션에서 한 번 로드됐으면 스킵
    if (sessionStorage.getItem(SESSION_KEY)) {
      return;
    }

    const getAnnouncementsMain = async () => {
      try {
        const res = await requestAxios<Announcement[]>(false, {
          url: '/users/announcements/main/',
          method: 'get',
        });
        const webAnnouncements = res.filter((r) => r.platforms.includes('web'));

        if (webAnnouncements.length > 0) {
          setMainAnnouncements(webAnnouncements);
        }
        sessionStorage.setItem(SESSION_KEY, 'true');
      } catch (err) {
        console.error('공지사항 로딩 실패', err);
      }
    };

    getAnnouncementsMain();
  }, [userInfo, requestAxios, setMainAnnouncements]);

  return;
};

export default useAnnouncement;
